import { render, staticRenderFns } from "./index.html?vue&type=template&id=46aa7e4e&scoped=true&"
import script from "./ProgrammeSubjectImport.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubjectImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa7e4e",
  null
  
)

export default component.exports